import React, { Component, Fragment } from 'react';

import { List, AutoSizer } from 'react-virtualized';

import { VisitorStatus } from 'components/shared/StatusHelper';

import { toFriendlyDateTimeString } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { MuiThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core';

class VisitorsMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      rowData: {},
    };
  }

  handleClick = (event, rowData) => {
    this.setState({ anchorEl: event.currentTarget, rowData: rowData });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, rowData: {} });
  };

  changeStatus = statusName => {
    let visitorData = this.state.rowData;
    if (statusName === 'checked_in') {
      visitorData['check_in'] = true;
    } else {
      visitorData['check_out'] = true;
    }
    this.props.createOrUpdateVisitor(visitorData, visitorData.id).then(() => {
      this.handleClose();
    });
  };

  rowRenderer = ({ key, index, style }, data) => {
    const visitors = data;
    let rowStyle = Object.assign({ borderBottom: `1px solid ${colors.LIGHT_GRAY}` }, style);

    return (
      <div id="mobile_card" key={key} style={rowStyle}>
        <div className="row">
          <div className="mobile_header">
            {' '}
            <b style={{ fontFamily: 'Circular-Bold' }}>{visitors[index].full_name}</b>
          </div>
          <div style={{ float: 'right', marginTop: '4px' }}>
            <MuiThemeProvider
              theme={createMuiTheme({
                overrides: {
                  MuiButton: {
                    root: {
                      minWidth: '20px',
                      minHeight: '20px',
                      margin: '0 5px',
                    },
                  },
                },
              })}
            >
              <Button
                aria-owns={this.state.anchorEl ? 'simple-menu' : null}
                aria-haspopup="true"
                onClick={event => this.handleClick(event, visitors[index])}
                style={{ padding: 0, height: '20px !important', minWidth: '20px !important' }}
              >
                <span>{<VisitorStatus status={visitors[index].status} />}</span>
              </Button>
            </MuiThemeProvider>
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            <b style={{ fontFamily: 'Circular' }}>
              Visiting {visitors[index].unit_number} {visitors[index].property_name}
            </b>
          </div>
        </div>
        {visitors[index].status === 'pending_arrival' && (
          <div className="row">
            <div className="mobile_subheader">
              Expected check in {toFriendlyDateTimeString(visitors[index].expected_arrival_at)}
            </div>
          </div>
        )}
        {(visitors[index].status === 'checked_in' || visitors[index].status === 'stale') && (
          <div className="row">
            <div className="mobile_subheader">
              Expected check out {toFriendlyDateTimeString(visitors[index].expected_departure_at)}
            </div>
          </div>
        )}
        {visitors[index].status === 'checked_out' && (
          <div className="row">
            <div className="mobile_subheader">
              Checked out on {toFriendlyDateTimeString(visitors[index].checked_out_at)}
            </div>
          </div>
        )}
        <div className="row">
          <div className="mobile_subheader">
            <button
              type="button"
              className="link-button"
              onClick={() => this.props.toggleVisitorDetailsDialog(visitors[index])}
            >
              view details
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const DEFAULT_ROW_HEIGHT = 118;

    const VisitorStatuses = ['checked_in', 'checked_out'];

    return (
      <Fragment>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
        >
          {VisitorStatuses.map((statusName, index) => (
            <MenuItem
              onClick={() => this.changeStatus(statusName)}
              disabled={statusName === this.state.rowData.status}
              selected={statusName === this.state.rowData.status}
              key={index}
            >
              <span>{<VisitorStatus status={statusName} />}</span>
            </MenuItem>
          ))}
        </Menu>
        <div className="mobile_card" style={{ height: 'calc(100% - 43px)', margin: '0 -15px' }}>
          {this.props.data.length === 0 && (
            <div id="mobile_card">
              <div className="row">
                <p
                  style={{
                    textAlign: 'center',
                    color: 'rgba(0,0,0,0.5)',
                    marginTop: '13px',
                  }}
                >
                  {' '}
                  You don&rsquo;t have any pending visitors{' '}
                </p>
              </div>
            </div>
          )}
          <AutoSizer>
            {({ height, width }) => (
              <List
                rowCount={this.props.data.length}
                rowHeight={DEFAULT_ROW_HEIGHT}
                rowRenderer={({ key, index, style }, data) =>
                  this.rowRenderer({ key, index, style }, this.props.data)}
                width={width}
                height={height}
              />
            )}
          </AutoSizer>
        </div>
      </Fragment>
    );
  }
}

export default VisitorsMobile;
